import React from 'react'
import PropTypes from 'prop-types'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import IconButton from '@material-ui/core/IconButton'
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft'
import KeyBoardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'

const styles = {
    footerContent: {
        position: 'absolute',
        right: 0
    },
    footerText: {
        position: 'absolute',
        paddingTop: 18,
        height: 16,
        right: 150
    }
};
export default class Pagination extends React.Component {
    render() {
        const {index, total, size, onPageClick} = this.props;
        return (
                <TableRow>
                <TableCell style={styles.footerContent}>
                    <IconButton disabled={index === 0} onClick={()=>onPageClick(index - 1)}>
                        <KeyboardArrowLeftIcon />
                    </IconButton>
                    <IconButton disabled={(index + 1) * size >= total} onClick={()=>onPageClick(index + 1)}>
                        <KeyBoardArrowRightIcon />
                    </IconButton>
                </TableCell>
                <TableCell style={styles.footerText}>
                    {Math.min((index * size) + 1, total) + '-' + Math.min((((index + 1) * size)), total) + ' of ' + total + ',总页数' + Math.ceil(total / size) + ', 当前第'}
                    <input type="number" defaultValue={index + 1} onFocus={(e) => e.target.select()} onChange={(e) => e.target.value > 0 && onPageClick(e.target.value - 1)}/>
                    {'页'}
                </TableCell>
            </TableRow>      
        );
    }

}
Pagination.propTypes = {
    index: PropTypes.number.isRequired, // current index
    total: PropTypes.number.isRequired, // total number of rows
    size: PropTypes.number.isRequired, // num of rows in each page
    onPageClick: PropTypes.func // what to do after clicking page number
}


// WEBPACK FOOTER //
// ./src/uis/pagination.js